import { Flex } from "antd";
import React, { Suspense } from "react";
import { useAuth } from "react-oidc-context";
import { useLocation } from "react-router-dom";
import LoadingSvg from "./assets/images/loader-icon.gif";
import "./index.css";
import MainLayout from "./layouts/AppLayout/AppLayout";
import AuthLayout from "./layouts/AuthLayout/AuthLayout";
import OnboardingLayout from "./layouts/OnboardingLayout/OnboardingLayout";
import AppRoutes from "./routes";
import { RulesProvider } from "./contexts/RulesContext";

function App() {
  const auth = useAuth();
  const location = useLocation();

  const isOnboarding = location.pathname === '/onboarding';

  if (auth.isLoading) {
    return (
      <Flex
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <img src={LoadingSvg} height={200} width={200} alt="LoadingSvg" />
      </Flex>
    );
  }

  if (auth.isAuthenticated) {
    localStorage.setItem("access_token", auth.user?.access_token);
  }

  if (auth.error) {
    localStorage.removeItem("access_token", auth.user?.access_token);
    return <div>Authentication Error: {auth.error.message}</div>;
  }

  // Onboarding is a public route with its own minimal layout —
  // skip MainLayout and AuthLayout entirely.
  if (isOnboarding) {
    return (
      <RulesProvider>
        <Suspense
          fallback={
            <Flex
              style={{ justifyContent: "center", alignItems: "center", height: "80vh" }}
            >
              <img src={LoadingSvg} height={200} width={200} alt="LoadingSvg" />
            </Flex>
          }
        >
          <OnboardingLayout>
            <AppRoutes />
          </OnboardingLayout>
        </Suspense>
      </RulesProvider>
    );
  }

  return (
    <RulesProvider>
    <Suspense
      fallback={
        <Flex
          style={{
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <img src={LoadingSvg} height={200} width={200} alt="LoadingSvg" />
        </Flex>
      }
    >
      {auth.isAuthenticated ? (
        <MainLayout auth={auth}>
          <AppRoutes />
        </MainLayout>
      ) : (
        <AuthLayout>
          <AppRoutes />
        </AuthLayout>
      )}
    </Suspense>
    </RulesProvider>
  );
}

export default App;
